import React from 'react';
import Navbar from '../components/navbar/navbar';
import Footer from '../components/footer/footer';
import AboutBody from '../components/body/aboutBody';
import Generic from '../components/body/generic';

const Aboutpage = () => {
    return (
        <>
     
        
        <AboutBody/>
        <Generic/>
        
        
        </>
    );
}

export default Aboutpage;
